import { chakra } from '@chakra-ui/react'
import { Grid as CkGrid, SimpleGrid as CkSimpleGrid } from '@chakra-ui/react'

export const MainWrapper = chakra(CkGrid, {
  baseStyle: () => ({
    gridTemplateColumns: 'minmax(0, 1fr))',
    gridColumnGap: { base: '0', lg: 8 },
    gridRowGap: { base: '0' },
    width: '100%'
  })
})

export const RoomWrapper = chakra(CkSimpleGrid, {
  baseStyle: () => ({
    width: '100%',
    display: { base: 'none', md: 'grid' },
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: 4,
    justifyContent: 'center',
    background: 'white',
    left: 0,
    top: 0
  })
})

export const RoomWrapperMobile = chakra(CkSimpleGrid, {
  baseStyle: () => ({
    display: { base: 'grid', md: 'none' },
    gridTemplateColumns: 'repeat(1, minmax(0, 1fr))',
    width: '100%',
    gap: 4
  })
})
